import _extends from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["icon", "title", "loading", "disabled", "subtleDisabled", "className", "children"],
  _excluded2 = ["className", "children"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { LoadingOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { DixuCol, DixuRow } from "../DixuGrid/DixuGrid";
import DixuImage from "../DixuImage/DixuImage";
import DixuText from "../DixuText/DixuText";
import { chunk } from 'lodash';
import React from 'react';
const DixuCardButton = _ref => {
  let {
      icon,
      title,
      loading,
      disabled,
      subtleDisabled,
      className,
      children
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const classes = classNames('dixu-card-button', 'box-shadow-2', className, {
    'dixu-card-button--loading': loading,
    'dixu-card-button--subtle-disabled': subtleDisabled
  });
  const Icon = (() => {
    if (typeof icon === 'string') {
      return /*#__PURE__*/React.createElement(DixuImage, {
        src: icon,
        plain: true
      });
    }
    return icon;
  })();
  const renderedIcon = loading ? /*#__PURE__*/React.createElement(LoadingOutlined, null) : Icon;
  return /*#__PURE__*/React.createElement("button", _objectSpread({
    className: classes,
    type: 'button',
    disabled: loading || disabled
  }, rest), /*#__PURE__*/React.createElement("span", {
    className: "dixu-card-button__content-container"
  }, renderedIcon && /*#__PURE__*/React.createElement("span", {
    className: "dixu-card-button__icon",
    "aria-hidden": "true"
  }, renderedIcon), /*#__PURE__*/React.createElement("span", null, title && /*#__PURE__*/React.createElement(DixuText, {
    font: "3",
    weight: "bold",
    color: "2-8",
    block: true,
    className: "dixu-card-button__title m-b-4"
  }, title), children && /*#__PURE__*/React.createElement(DixuText, {
    font: "2",
    color: "2-8",
    weight: "medium",
    tag: "div",
    className: "dixu-card-button__content"
  }, children))));
};
DixuCardButton.defaultProps = {
  icon: undefined,
  title: undefined,
  loading: false,
  disabled: false
};
const DixuCardButtonGroup = _ref2 => {
  let {
      className,
      children
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  const classes = classNames('dixu-card-button-group', className);
  const chunkedChildren = chunk(React.Children.toArray(children), 3);
  const mappedChildren = chunkedChildren.flatMap(row => {
    const rowLength = row.length;
    return React.Children.map(row, (child, index) => {
      return /*#__PURE__*/React.createElement(DixuCol, {
        key: index.toString(36),
        xs: 24,
        xl: 24 / rowLength
      }, child);
    });
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, rest), /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [16, 16]
  }, mappedChildren));
};
DixuCardButton.defaultProps = {
  icon: undefined,
  title: undefined,
  loading: undefined,
  subtleDisabled: undefined
};
DixuCardButton.Group = DixuCardButtonGroup;
export default DixuCardButton;